module.exports = __webpack_public_path__ + "static/media/tutorial-09.5dc1a334.jpg";